import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = '40px', color = '#007bff' }) => {
  const spinnerStyle = {
    width: size,
    height: size,
    borderTopColor: color,
    borderRightColor: color,
    borderBottomColor: color,
    borderLeftColor: 'transparent', 
  };

  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner" style={spinnerStyle}></div>
    </div>
  );
};

export default LoadingSpinner; 